import { render, staticRenderFns } from "./clientdashboard-profile-ceg.vue?vue&type=template&id=220ea656&"
import script from "./clientdashboard-profile-ceg.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-profile-ceg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports